import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

const LEVELS = {
  high: {
    bg: "#DAF3F6",
    color: "#125661",
    label: "High confidence",
    info: "High confidence: the engine found clear evidence for this. You can rely on it, but change it if it looks wrong.",
  },
  medium: {
    bg: "#FBEAC0",
    color: "#795200",
    label: "Medium confidence",
    info: "Medium confidence: a reasonable inference from partial evidence. Worth a quick check.",
  },
  low: {
    bg: "#FAD7D7",
    color: "#9C1C1C",
    label: "Low confidence",
    info: "Low confidence: a best guess from thin evidence. Please confirm this one, it can change the verdict.",
  },
  unknown: {
    bg: "#E1E5EA",
    color: "#3F4A5A",
    label: "Unknown",
    info: "Unknown: not enough information to judge. Set the assumption or tell the copilot to improve it.",
  },
};

export const ConfidenceChip = ({ level, needsConfirm }) => {
  const s = LEVELS[level] || LEVELS.unknown;
  return (
    <span className="inline-flex items-center gap-1.5">
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="cursor-help rounded px-2 py-0.5 text-[11px] font-semibold"
            style={{ background: s.bg, color: s.color }}
            data-testid="confidence-chip"
          >
            {s.label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[240px] bg-asphalt text-white">{s.info}</TooltipContent>
      </Tooltip>
      {needsConfirm && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className="gl-pulse cursor-help rounded px-2 py-0.5 text-[11px] font-bold text-white"
              style={{ background: "#D64545" }}
            >
              Please confirm
            </span>
          </TooltipTrigger>
          <TooltipContent className="max-w-[240px] bg-asphalt text-white">
            This assumption drives the verdict and is uncertain. Confirm or correct it so the classification is reliable.
          </TooltipContent>
        </Tooltip>
      )}
    </span>
  );
};

export const ConfidenceLegend = () => (
  <div className="flex flex-wrap items-center gap-3 text-xs text-muted" data-testid="confidence-legend">
    <span className="font-medium text-asphalt">Confidence (hover for detail):</span>
    <ConfidenceChip level="high" />
    <ConfidenceChip level="medium" />
    <ConfidenceChip level="low" />
    <ConfidenceChip level="unknown" />
  </div>
);
